import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import clientsImg from "./../../../assets/global_assets/clients.jpg";
import UnitsImg from "./../../../assets/global_assets/clients.jpg";
import AnchorsImg from "./../../../assets/global_assets/clients.jpg";
import dashboard_box_icon_1 from "../../../assets/global_assets/dashboard_imgs/superadmin_icons/icons1.png";
import dashboard_box_icon_2 from "../../../assets/global_assets/dashboard_imgs/superadmin_icons/icons2.png";
import dashboard_box_icon_3 from "../../../assets/global_assets/dashboard_imgs/superadmin_icons/icons3.png";
import dashboard_box_icon_4 from "../../../assets/global_assets/dashboard_imgs/superadmin_icons/icons4.png";
import dashboard_box_icon_5 from "../../../assets/global_assets/dashboard_imgs/superadmin_icons/icons5.png";
import dashboard_download_icon from "../../../assets/global_assets/dashboard_imgs/superadmin_icons/download_icon.png";
import dashboard_update_icon from "../../../assets/global_assets/dashboard_imgs/superadmin_icons/update_icon.png";
import dashboard_upload_icon from "../../../assets/global_assets/dashboard_imgs/superadmin_icons/upload_icon.png";
import dashboard_returns_1m from "../../../assets/global_assets/dashboard_imgs/superadmin_icons/download_returns-1m.png";
import dashboard_returns_3m from "../../../assets/global_assets/dashboard_imgs/superadmin_icons/download_returns-3m.png";
import dashboard_returns_6m from "../../../assets/global_assets/dashboard_imgs/superadmin_icons/download_returns-6m.png";
import dashboard_returns_1y from "../../../assets/global_assets/dashboard_imgs/superadmin_icons/download_returns-1y.png";
import calendarfy from "../../../assets/global_assets/dashboard_imgs/superadmin_icons/calendarfy.png";
import Chart from "react-apexcharts";
import Stack from '@mui/material/Stack';
import "./dashboard.css"
import { ResponsiveLine } from '@nivo/line'
import { ResponsivePie } from '@nivo/pie'
import { BarChart } from '@mui/x-charts'; import {
  FaBuilding,
  FaCubes,
  FaMicrochip,

} from 'react-icons/fa';
import { FaShoppingCart, FaShoppingBag, FaUser, FaDollarSign } from 'react-icons/fa';
// import { desktopOS, valueFormatter } from './webUsageStats';
import { LineChart } from '@mui/x-charts/LineChart';
import ReactApexChart from 'react-apexcharts';
import { getEmployeeCount,getLogActivities,getUpcomingHolidays } from '../../../services/global_redux/globale_actions/Dashboard.action';
import { fetchGeneratedFormsList } from '../../../services/register_redux/register_actions/generateForm.action';
const DashboardCard = ({ icon, title, value, color, bg }) => (
  <div className="col-md-4 mb-4 ">
    <div className="card shadow-sm">
      <div className="card-body align-items-center dashboardCard"style={{
            backgroundColor: bg,}}>
        <div
          className=" align-items-center justify-content-center "
          style={{
            borderRadius: '50%',
            width: '60px',
            height: '60px',
          }}
        >
          <div style={{ color }}>
          <img src={icon} alt="icon" width="40" height="40" /> </div>
        </div>
        <div>
          <h4 className="mb-0">{value}</h4>
          <h6 className="mb-0">{title}</h6>
        </div>
      </div>
    </div>
  </div>
);






const data = [
  { id: 0, value: 8167, label: 'A' },
  { id: 1, value: 1492, label: 'B' },
  { id: 2, value: 2782, label: 'C' },
  { id: 3, value: 4253, label: 'D' },
  { id: 4, value: 8702, label: 'E' },
  { id: 5, value: 1702, label: 'F' },
  { id: 6, value: 10702, label: 'G' },
];

function isThisOrNextMonth(isoDate) {
  const match = String(isoDate || "").match(/^(\d{4})-(\d{2})/);
  if (!match) return false;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const now = new Date();
  const thisYear = now.getFullYear();
  const thisMonth = now.getMonth() + 1;
  const nextYear = thisMonth === 12 ? thisYear + 1 : thisYear;
  const nextMonth = thisMonth === 12 ? 1 : thisMonth + 1;
  return (year === thisYear && month === thisMonth) || (year === nextYear && month === nextMonth);
}

function monthToFinancialYear(yearMonth) {
  const [year, month] = String(yearMonth || "").split("-").map(Number);
  if (!year || !month) return "";
  const startYear = month >= 4 ? year : year - 1;
  return `${startYear}-${startYear + 1}`;
}


function Dashboard() {
  const dispatch = useDispatch();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [clients, setClients] = useState(0);
  const [units, setUnits] = useState(0);
  const [anchors, setAnchors] = useState(89);
  const [clientName, setClientName] = useState([]);
  const [unitCount, setUnitCount] = useState([]);
  const [totalclientName, setTotalClientName] = useState(0);
  const [totalunitCount, setTotalUnitCount] = useState(0);
  const [userRole, setUserRole] = useState(null);
  const [selectedFY, setSelectedFY] = useState("");
  const [formMonthCounts, setFormMonthCounts] = useState({});
  const [holidayFilterType, setHolidayFilterType] = useState("0");

  useEffect(() => {
    dispatch(getEmployeeCount());
    dispatch(getLogActivities());
    dispatch(getUpcomingHolidays());
  }, [dispatch]);

  useEffect(() => {
    if (userRole !== "Client") return;
    dispatch(getUpcomingHolidays());
  }, [dispatch, userRole]);

  useEffect(() => {
    if (userRole !== "Client") return;
    const loadGeneratedForms = async () => {
      let clientId = sessionStorage.getItem("selectedClient");
      if (!clientId || clientId === "null") {
        try {
          const user = JSON.parse(sessionStorage.getItem("user") || "{}");
          const mapped = JSON.parse(user.client_and_unit || "[]");
          clientId = String(mapped?.[0]?.client_id || "").trim();
        } catch {
          clientId = "";
        }
      }
      const response = await dispatch(fetchGeneratedFormsList({
        client_id: clientId || undefined,
        kind: "register",
        overview: true,
      }));
      const payload = response?.data;
      setFormMonthCounts(
        payload && !Array.isArray(payload) && typeof payload === "object" ? payload : {}
      );
    };
    loadGeneratedForms();
  }, [dispatch, userRole]);
  
const {employeeCount,logActivities,upcomingHolidays,loading,error} = useSelector((state) => state.dashboard_record);
  

  const lineData = [
    {
      id: "Forms",
      color: "hsl(210, 100%, 50%)",
      data: [
        { x: "Jan", y: 500 },
        { x: "Feb", y: 1200 },
        { x: "Mar", y: 1800 },
        { x: "Apr", y: 1500 },
        { x: "May", y: 2000 },
        { x: "Jun", y: 2300 },
        { x: "Jul", y: 2500 },
        { x: "Aug", y: 3000 },
      ]
    }
  ]

  const pieData = [
    { id: "Forms Pending", label: "Forms Pending", value: 37, color: "rgb(106,210,255)" },
    { id: "Forms Generated", label: "Forms Generated", value: 63, color: "rgb(0,87,255)" }
  ]

  const [barChartState, setBarChartState] = useState({
    series: [{ data: [] }],
    options: {
      chart: {
        height: 350,
        type: 'bar',
        events: {
          click: function (chart, w, e) {
            console.log('Bar clicked:', e);
          }
        }
      },
      colors: [
        "#008FFB", "#00E396", "#FEB019", "#FF4560",
        "#775DD0", "#3F51B5", "#546E7A", "#D4526E"
      ],
      plotOptions: {
        bar: {
          columnWidth: '45%',
          distributed: true,
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            colors: [],
            fontSize: '12px'
          }
        }
      }
    }
  });

  useEffect(() => {
    const user = sessionStorage.getItem('user');
    if (user) {
      const parsedClientArray = JSON.parse(user);
      const clientUnits = JSON.parse(parsedClientArray.client_and_unit);
      setUserRole(parsedClientArray.base_role);

      const clientUnitMap = {};
        if(Array.isArray(clientUnits)){

            clientUnits?.forEach(({ client_id, unit_id }) => {
                if (!clientUnitMap[client_id]) {
                clientUnitMap[client_id] = new Set();
                }

                if (Array.isArray(unit_id)) {
                unit_id.forEach(unit => clientUnitMap[client_id].add(unit));
                }
            });
        }

      // Convert to count
      const uniqueClients = Object.keys(clientUnitMap);
      const totalUnits = uniqueClients.map(client => clientUnitMap[client].size);
      const new_totalUnits = uniqueClients.reduce(
        (sum, client) => sum + clientUnitMap[client].size,
        0
      );
      setTotalClientName(uniqueClients.length)
      setTotalUnitCount(new_totalUnits)

      setBarChartState(prev => ({
        ...prev,
        series: [{ data: totalUnits }],
        options: {
          ...prev.options,
          xaxis: {
            ...prev.options.xaxis,
            categories: uniqueClients,
            labels: {
              ...prev.options.xaxis.labels,
              colors: uniqueClients.map(
                (_, i) => prev.options.colors[i % prev.options.colors.length]
              )
            }
          }
        }
      }));



    }
  }, []);
  const [chartData, setChartData] = useState({
    series: [44, 55, 13, 43, 22],
    options: {
      chart: {
        width: 380,
        type: 'pie',
      },
      labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    }
  });
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };


  const desktopOS = [
    { label: 'Windows', value: 72.72 },
    { label: 'OS X', value: 16.38 },
    { label: 'Linux', value: 3.83 },
    { label: 'Chrome OS', value: 2.42 },
    { label: 'Other', value: 4.65 },
  ];

  const mobileOS = [
    { label: 'Android', value: 70.48 },
    { label: 'iOS', value: 28.8 },
    { label: 'Other', value: 0.71 },
  ];

  const platforms = [
    { label: 'Mobile', value: 59.12 },
    { label: 'Desktop', value: 40.88 },
  ];

  const normalize = (v, v2) => Number.parseFloat(((v * v2) / 100).toFixed(2));

  const mobileAndDesktopOS = [
    ...mobileOS.map((v) => ({
      ...v,
      label: v.label === 'Other' ? 'Other (Mobile)' : v.label,
      value: normalize(v.value, platforms[0].value),
    })),
    ...desktopOS.map((v) => ({
      ...v,
      label: v.label === 'Other' ? 'Other (Desktop)' : v.label,
      value: normalize(v.value, platforms[1].value),
    })),
  ];

  // Format value for charts
  const valueFormatter = (item) => `${item.value}%`;

  // Data config (choose one)
  const datas = {
    data: mobileAndDesktopOS, // OR mobileOS, OR mobileAndDesktopOS
    valueFormatter,
  };

  // Size config for the chart
  const size = {
    width: 400,
    height: 400,
  };

  const margin = { right: 24 };
  const uData = [4000, 3000, 2000, 2780, 1890, 2390, 3490];
  const pData = [2400, 1398, 9800, 3908, 4800, 3800, 4300];
  const xLabels = [
    'Page A',
    'Page B',
    'Page C',
    'Page D',
    'Page E',
    'Page F',
    'Page G',
  ];



  // Build dynamic dataPoints
  const dataPoints = clientName.map((name, index) => ({
    label: name,
    y: unitCount[index]
  }));

  const options = {
    animationEnabled: true,
    // theme: "light2",
    title: {
      text: "Clients and Unit Count"
    },
    axisX: {
      title: "Clients",
    },
    axisY: {
      title: "Number of Units",
      includeZero: true,
    },
    data: [{
      type: "bar",
      // color: "#4287f5",
      dataPoints: dataPoints
    }]
  };



const upcomingHolidays_Data = upcomingHolidays?.upcoming_holidays;
const holidays = Array.isArray(upcomingHolidays_Data)
  ? upcomingHolidays_Data.map((holiday) => {
      const dateObj = new Date(`${String(holiday.hol_date || "").slice(0, 10)}T00:00:00`);
      return {
        name: holiday.hol_name,
        address: `${holiday.hol_state || ""}`,
        rawDate: holiday.hol_date,
        date: Number.isNaN(dateObj.getTime())
          ? String(holiday.hol_date || "")
          : dateObj.toLocaleDateString("en-GB", {
              day: "numeric",
              month: "short",
              year: "numeric",
            }),
        type: Number(holiday.hol_type) === 0 ? "Festival" : "National",
      };
    })
  : [];

const visibleHolidays = holidays.filter((holiday) => {
  if (userRole === "Client" && !isThisOrNextMonth(holiday.rawDate)) return false;
  if (holidayFilterType === "1") return holiday.type === "National";
  if (holidayFilterType === "2") return holiday.type === "Festival";
  return true;
});


const activities = Array.isArray(logActivities.recent_logs)
  ? logActivities.recent_logs.map((log) => {
      const createdAt = new Date(log.created_at);
      const actionTypeMap = {
        Create: 1,
        Update: 2,
        Upload: 3,
        Delete: 4,
        Download: 5,
        Generate: 6,
      };

      return {
        type: actionTypeMap[log.action] || 0,
        title: log.description || "Employee Master Has Been",
        action: `${log.action} by ${log.username}`,
        date: createdAt.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
          year: "numeric",
        }),
        time: createdAt.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }),
      };
    })
  : [];


  const returnsData = [
    { id: 1, label: "1M", form: "Form B", subtitle: "Quarterly", date: "Apr 3, 2026", color: "info" },
    { id: 2, label: "6M", form: "Form C", subtitle: "Half-Yearly", date: "Apr 15, 2026", color: "danger" },
    { id: 3, label: "1Y", form: "Form D", subtitle: "Yearly", date: "Apr 20, 2026", color: "success" },
    { id: 4, label: "3M", form: "Form A", subtitle: "Monthly", date: "Apr 25, 2026", color: "primary" },
  ];
  const dashboardOptions = {
    chart: {
      type: "area",
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    markers: {
      size: 5,
      colors: ["#fff"],
      strokeColors: "#3b82f6",
      strokeWidth: 2,
    },
    dataLabels: { enabled: false },
    grid: { borderColor: "#f0f0f0", strokeDashArray: 4 },
    xaxis: {
      categories: [
        "Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"
      ],
      labels: { style: { colors: "#9ca3af", fontSize: "13px" } }
    },
    yaxis: {
      labels: { style: { colors: "#9ca3af", fontSize: "13px" } }
    },
    tooltip: {
      theme: "light",
      style: { fontSize: "14px" },
      custom: function({ series, seriesIndex, dataPointIndex, w }) {
        return `
          <div class="dashboard-tooltip-card">
            <div class="dashboard-tooltip-title">${w.globals.categoryLabels[dataPointIndex]}</div>
            <div class="dashboard-tooltip-value">${series[seriesIndex][dataPointIndex]}K</div>
          </div>
        `;
      }
    },
    colors: ["#3b82f6"],
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0,
        stops: [0, 100],
      },
    },
  };

  const dashboardSeries = [
    {
      name: "Form Generated",
      data: [0, 10, 20, 20, 25, 30, 28, 35, 30, 40, 45, 42],
    },
  ];

  const getFinancialYearList = (count = 5) => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    let startYear = month >= 4 ? year : year - 1;

    return Array.from({ length: count }, (_, i) => {
      const y = startYear - i;
      return `${y}-${y + 1}`;
    });
  };

  const fyList = useMemo(() => {
    if (userRole !== "Client") {
      return getFinancialYearList();
    }
    const years = new Set();
    Object.entries(formMonthCounts || {}).forEach(([key, value]) => {
      const count = Number(value?.generated || 0);
      if (count <= 0) return;
      const fy = monthToFinancialYear(key);
      if (fy) years.add(fy);
    });
    return Array.from(years).sort((a, b) => Number(b.split("-")[0]) - Number(a.split("-")[0]));
  }, [formMonthCounts, userRole]);

  const fySelectValue = userRole === "Client" ? (selectedFY || fyList[0] || "") : selectedFY;

  const clientRegistersChart = useMemo(() => {
    const fyKey = selectedFY || fyList[0] || "";
    const startYear = Number(String(fyKey).split("-")[0]);
    const empty = { categories: [], forms: [] };
    if (!startYear) return empty;

    const monthDefs = [
      { label: "Apr", month: 4 },
      { label: "May", month: 5 },
      { label: "Jun", month: 6 },
      { label: "Jul", month: 7 },
      { label: "Aug", month: 8 },
      { label: "Sep", month: 9 },
      { label: "Oct", month: 10 },
      { label: "Nov", month: 11 },
      { label: "Dec", month: 12 },
      { label: "Jan", month: 1 },
      { label: "Feb", month: 2 },
      { label: "Mar", month: 3 },
    ];
    const slots = monthDefs.map((item) => {
      const year = item.month >= 4 ? startYear : startYear + 1;
      return {
        label: item.label,
        key: `${year}-${String(item.month).padStart(2, "0")}`,
      };
    });

    const forms = slots.map((slot) => Number(formMonthCounts?.[slot.key]?.generated || 0));
    let lastDataIdx = -1;
    forms.forEach((count, idx) => {
      if (count > 0) lastDataIdx = idx;
    });
    if (lastDataIdx < 0) return empty;

    return {
      categories: slots.slice(0, lastDataIdx + 1).map((slot) => slot.label),
      forms: forms.slice(0, lastDataIdx + 1),
    };
  }, [formMonthCounts, selectedFY, fyList]);

  const clientDashboardOptions = {
    ...dashboardOptions,
    xaxis: {
      ...dashboardOptions.xaxis,
      categories: clientRegistersChart.categories,
    },
    legend: { show: false },
    tooltip: {
      theme: "light",
      style: { fontSize: "14px" },
      custom: function({ series, seriesIndex, dataPointIndex, w }) {
        return `
          <div class="dashboard-tooltip-card">
            <div class="dashboard-tooltip-title">${w.globals.categoryLabels[dataPointIndex]}</div>
            <div class="dashboard-tooltip-value">${series[seriesIndex][dataPointIndex]}</div>
          </div>
        `;
      }
    },
  };
  const clientDashboardSeries = [
    {
      name: "Form Generated",
      data: clientRegistersChart.forms,
    },
  ];


  const holidayFilter = (data)=>{
    if(data == 0){

    }else if(data == 1){
      
    }else if(data == 2){
      
    }
  }
  const activityFilter = (data)=>{
    if(data == 0){

    }else if(data == 1){
      
    }else if(data == 2){
      
    }
  }
  return (
    <div className="container-fluid dahsboard-main-container pb-3">
      <div className="row ">
        <div className="col-md-12">
        {userRole === "SuperiorAdmin" && (
            // <div className="row mt-3">
            //     <h4>SuperAdmin</h4>
            //     <div className="row">
            //     <DashboardCard
            //         icon={clientsImg}
            //         title="Clients"
            //         value={totalclientName}
            //         color="green"
            //         bg="rgba(0,255,0,0.25)"
            //     />
            //     <DashboardCard
            //         icon={UnitsImg}
            //         title="Units"
            //         value={totalunitCount}
            //         color="blue"
            //         bg="rgba(0,0,255,0.25)"
            //     />
            //     <DashboardCard
            //         icon={AnchorsImg}
            //         title="Anchors"
            //         value={anchors}
            //         color="purple"
            //         bg="rgb(13, 223, 255)"
            //     />
            //     </div>

            //     <div className="row ">
            //     <div className="col-md-6 d-flex">
            //         <div className="chart-card p-3 border rounded bg-white w-100 h-350">
            //         <ReactApexChart
            //             options={barChartState.options}
            //             series={barChartState.series}
            //             type="bar"
            //             height={350}
            //             width="85%"
            //         />
            //         </div>
            //     </div>
            //     <div className="col-md-6 d-flex">
            //         <div className="chart-card p-3 border rounded bg-white w-100 h-350">
            //         <ReactApexChart
            //             options={chartData.options}
            //             series={chartData.series}
            //             type="pie"
            //             height={350}
            //             width="80%"
            //         />
            //         </div>
            //     </div>
            //     </div>


            // </div>
            <div className="row dahsboard-main-row">
              <div className="col-md-12">
                <div className="row dahsboard-box-row">
                  <div className="col  dishboard-box-1 m-2">
                    <div className="row m-0">
                      <div className="col-md-12 d-flex justify-content-between  mt-3 p-0">
                        <p className="dashboard-lable-number p-0 m-0">{employeeCount.totals.total_clients}</p>
                        <div className="dashboard-lable-icon-div">
                        <img className='dashboard-lable-icon ' src={dashboard_box_icon_1} alt="no-img" />
                        </div>
                     </div>
                      <div className="col-md-12 p-0 m-0 mt-3">
                        <p className="dashboard-lable-text  m-0 p-0">Organization</p>
                      </div>
                    </div>
                  </div>
                  <div className="col  dishboard-box-2 m-2">
                    <div className="row m-0">
                      <div className="col-md-12 d-flex justify-content-between  mt-3 p-0">
                        <p className="dashboard-lable-number p-0 m-0">{employeeCount.totals.total_units}</p>
                        <div className="dashboard-lable-icon-div">
                        <img className='dashboard-lable-icon ' src={dashboard_box_icon_2} alt="no-img" />
                        </div>
                     </div>
                      <div className="col-md-12 p-0 m-0 mt-3">
                        <p className="dashboard-lable-text  m-0 p-0">Branches</p>
                      </div>
                    </div>
                  </div>
                  <div className="col  dishboard-box-3 m-2">
                    <div className="row m-0">
                      <div className="col-md-12 d-flex justify-content-between  mt-3 p-0">
                        <p className="dashboard-lable-number p-0 m-0">{employeeCount.totals.total_active}</p>
                        <div className="dashboard-lable-icon-div">
                        <img className='dashboard-lable-icon ' src={dashboard_box_icon_3} alt="no-img" />
                        </div>
                     </div>
                      <div className="col-md-12 p-0 m-0 mt-3">
                        <p className="dashboard-lable-text  m-0 p-0">Employee Head Count</p>
                      </div>
                    </div>
                  </div>
                  <div className="col  dishboard-box-4 m-2">
                    <div className="row m-0">
                      <div className="col-md-12 d-flex justify-content-between  mt-3 p-0">
                        <p className="dashboard-lable-number p-0 m-0">{employeeCount.totals.total_latest_joined}</p>
                        <div className="dashboard-lable-icon-div">
                        <img className='dashboard-lable-icon ' src={dashboard_box_icon_4} alt="no-img" />
                        </div>
                     </div>
                      <div className="col-md-12 p-0 m-0 mt-3">
                        <p className="dashboard-lable-text  m-0 p-0">New Employees</p>
                      </div>
                    </div>
                  </div>
                  <div className="col  dishboard-box-5 m-2">
                    <div className="row m-0">
                      <div className="col-md-12 d-flex justify-content-between  mt-3 p-0">
                        <p className="dashboard-lable-number p-0 m-0">{employeeCount.totals.total_separated}</p>
                        <div className="dashboard-lable-icon-div">
                        <img className='dashboard-lable-icon ' src={dashboard_box_icon_5} alt="no-img" />
                        </div>
                     </div>
                      <div className="col-md-12 p-0 m-0 mt-3">
                        <p className="dashboard-lable-text  m-0 p-0">Exit Employees</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="row p-2 mt-1">
                  <div className="col-md-6 ">
                    <div className="row bg-white dashboard-chart1 pt-3" data-tour="dashboard-registers">
                    <div className="d-flex justify-content-between items-center mb-2">
      <h5 className="text-lg font-semibold">Registers Overview</h5>

      <select
        value={fySelectValue}
        onChange={(e) => setSelectedFY(e.target.value)}
        className="custom-select-registers"
        style={{
          backgroundImage: `url(${calendarfy})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "8px center",
          paddingLeft: "30px",
          backgroundSize: "18px 18px",
        }}
      >
        {userRole === "Client" ? (
          fyList.length === 0 ? (
            <option value="">No forms</option>
          ) : (
            fyList.map((fy) => (
              <option key={fy} value={fy}>
                {fy}
              </option>
            ))
          )
        ) : (
          <>
            <option value=""> This FY</option>
            {fyList.map((fy, idx) => (
              <option key={idx} value={fy}>
                {fy}
              </option>
            ))}
          </>
        )}
      </select>
    </div>
                    <div className="dashboard-chart-wrapper">
      <Chart
        key={userRole === "Client" ? `client-fy-${fySelectValue}-${clientRegistersChart.categories.join("-")}` : "admin-registers"}
        options={userRole === "Client" ? clientDashboardOptions : dashboardOptions}
        series={userRole === "Client" ? clientDashboardSeries : dashboardSeries}
        type="area"
        height={200}
      />
    </div>
                    {/* <div className="bg-white shadow-md rounded-2xl p-5 relative">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">Registers Overview</h2>
          <button className="flex items-center gap-2 text-sm border rounded-lg px-3 py-1 bg-gray-50 hover:bg-gray-100">
            📅 This FY
          </button>
        </div>

        <p className="text-blue-600 font-bold text-2xl">3K</p>
        <p className="text-gray-500 text-sm mb-2">Total Number of Form Generated</p>

        <div style={{ height: 260 }}>
          <ResponsiveLine
            data={lineData}
            margin={{ top: 20, right: 20, bottom: 40, left: 50 }}
            xScale={{ type: "point" }}
            yScale={{ type: "linear", min: "auto", max: "auto" }}
            axisBottom={{ tickSize: 0, tickPadding: 10 }}
            axisLeft={{ tickSize: 0, tickPadding: 10 }}
            colors={["#2563EB"]}
            lineWidth={3}
            enablePoints={true}
            pointSize={12}
            pointColor="#fff"
            pointBorderWidth={3}
            pointBorderColor="#2563EB"
            enableGridX={false}
            enableGridY={true}
            useMesh={true}
            theme={{
              textColor: "#6B7280",
              axis: { ticks: { text: { fontSize: 12 } } },
              grid: { line: { stroke: "#E5E7EB", strokeWidth: 1 } },
              tooltip: {
                container: {
                  background: "white",
                  padding: "8px 12px",
                  borderRadius: "8px",
                  fontSize: 12,
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                },
              },
            }}
            tooltip={({ point }) => (
              <div className="bg-white shadow-md rounded-lg p-2 text-sm">
                <p className="font-semibold">{point.data.xFormatted}</p>
                <p className="text-blue-600">Form Generated: {point.data.yFormatted}</p>
              </div>
            )}
          />
        </div>
      </div> */}
                    </div>
                  </div>
                  <div className="col-md-3 p-0 m-0 ">
                    <div className="row bg-white   dashboard-chart2" data-tour="dashboard-status">
                    <div className="dashboard-status-card">
                        {/* Header */}
                        <div className="dashboard-status-card">
                        {/* Header */}
                        <div className="dashboard-status-header">
                          <h5>Status Chart</h5>
                          <select className=" w-auto custom-select-status">
                            <option>Monthly</option>
                            <option>Quarterly</option>
                            <option>Yearly</option>
                          </select>
                        </div>

                        {/* Chart */}
                          <div className="dashboard-status-chart">
                            <ResponsivePie
                              data={pieData}
                              margin={{ top: 22, right: 22, bottom: 22, left: 22 }}
                              innerRadius={0}
                              enableArcLabels={false}
                              enableArcLinkLabels={false}
                              colors={(d) => d.data.color}
                              isInteractive={true}
                              activeOuterRadiusOffset={6}
                              tooltip={() => null}
                              arcLabel={(d) => `${d.value}%`}
                              arcLabelsSkipAngle={0}
                              arcLabelsTextColor="#fff" // set to final color
                              startAngle={-133}   // 👈 rotates start to left
                              endAngle={360}
                            />


                          </div>

                        {/* Legend */}
                        <div className="dashboard-status-legend">
                          {pieData.map((item, idx) => (
                            <>
                            <div key={idx} className="dashboard-status-item">
                              
                              <div>
                                <p className="dashboard-label"><span
                                className="dashboard-dot"
                                style={{ backgroundColor: item.color }}
                              ></span>{item.label}</p>
                                <p className="dashboard-value">{item.value}%</p>
                              </div>
                            </div>
                              {item.label === "Forms Pending" && <div className='dashboard-dot-line'></div>}
                              </>
                          ))}
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                  <div className="col-md-3  p-0 m-0">
                    <div className="row  bg-white   dashboard-chart3 bg-white shadow-sm returns-card" data-tour="dashboard-returns">

                        {/* Header */}
                        <div className="d-flex justify-content-between align-items-center mb-0 returns-card-header mt-2">
                          <h6 className="fw-bold mb-0">Returns</h6>
                          <div className="btn-group btn-group-sm return-btn-main">
                            <button className="return-btn active">1M</button>
                            <button className="return-btn">3M</button>
                            <button className="return-btn">6M</button>
                            <button className=" return-btn">1Y</button>
                          </div>  
                        </div>

                        {/* Scrollable List */}
                        <div className="dashboard-returns-list mt-2">
                          {returnsData.map((item) => (
                            <div key={item.id} className="d-flex align-items-center justify-content-between mb-3">
                              <div className="d-flex align-items-center">
                                <div>
                                  {/* {item.label} */}
                                  {(() => {
                                      switch (item.label) {
                                        case "1M":
                                          return <div className="dashboard_returns_1m returns-icon-div"><img src={dashboard_returns_1m} alt="icon" className="returns-icon" /></div>;
                                        case "3M":
                                          return <div className="dashboard_returns_3m returns-icon-div"><img src={dashboard_returns_3m} alt="icon" className="returns-icon" /></div>;
                                        case "6M":
                                          return <div className="dashboard_returns_6m returns-icon-div"><img src={dashboard_returns_6m} alt="icon" className="returns-icon" /></div>;
                                        case "1Y":
                                          return <div className="dashboard_returns_1y returns-icon-div"><img src={dashboard_returns_1y} alt="icon" className="returns-icon" /></div>;
                                        default:
                                          return <div className="dashboard_returns_1m returns-icon-div"><img src={dashboard_returns_1m} alt="icon" className="returns-icon" /></div>;
                                      }
                                  })()}
                                </div>
                                <div>
                                  <div className="form">{item.form}</div>
                                  <div className=" subtitle">{item.subtitle}</div>
                                </div>
                              </div>
                              <div className="text-end  date">{item.date}</div>
                            </div>
                          ))}
                        </div>
                    </div>
                    
                  </div>
                </div>
              </div>
              <div className="col-md-12 dashboard3card">
                <div className="row p-0 m-0 ">
                  {userRole === "Client" ? (
                  <div className="col-md-12  p-0 m-0">
                    <div className="row bg-white dashboard-table-1 client-holidays-expanded" data-tour="dashboard-holidays">
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-3 holidaymainheader">
                        <h5 className="fw-bold mt-1">Upcoming Holidays</h5>
                        <select className=" w-auto custom-select" value={holidayFilterType} onChange={(e) => setHolidayFilterType(e.target.value)}>
                          <option value = "0">All Holidays</option>
                          <option value = "2">Festival Holidays</option>
                          <option value = "1">National Holidays</option>
                        </select>
                      </div>

                      <div className="table-responsive holiday-table-main">
                      <table className="table holiday-table table-borderless  table-striped">
                        <thead className=''>
                          <tr className='p-1'>
                            <th>Name of the Festival</th>
                            <th>State</th>
                            <th>Date</th>
                            <th>Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          {visibleHolidays.length === 0 ? (
                            <tr>
                              <td colSpan={4} className="text-center text-muted py-4">No holidays</td>
                            </tr>
                          ) : (
                            visibleHolidays.map((holiday, index) => (
                            <tr key={index} >
                              <td>{holiday.name}</td>
                              <td>{holiday.address}</td>
                              <td>{holiday.date}</td>
                              <td>
                                <span className={`holidaybadge ${
                                    holiday.type === "National" ? "textdark nationalholiday" : " festivalholiday"
                                  }`}>{holiday.type}
                                </span>
                              </td>
                            </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                      </div>
                    </div>
                    </div>
                  </div>
                  ) : (
                  <>
                  <div className="col-md-6  p-0 m-0">
                    <div className="row bg-white dashboard-table-1">
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-3 holidaymainheader">
                        <h5 className="fw-bold mt-1">Upcoming Holidays</h5>
                        <select className=" w-auto custom-select" onChange={(e) => holidayFilter(e.target.value)}>
                          <option value = "0">All Holidays</option>
                          <option value = "2">Festival Holidays</option>
                          <option value = "1">National Holidays</option>
                        </select>
                      </div>

                      <div className="table-responsive holiday-table-main">
                      <table className="table holiday-table table-borderless  table-striped">
                        <thead className=''>
                          <tr className='p-1'>
                            <th>Name of the Festival</th>
                            <th>State</th>
                            <th>Date</th>
                            <th>Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          {holidays.map((holiday, index) => (
                            <tr key={index} >
                              <td>{holiday.name}</td>
                              <td>{holiday.address}</td>
                              <td>{holiday.date}</td>
                              <td>
                                <span className={`holidaybadge ${
                                    holiday.type === "National" ? "textdark nationalholiday" : " festivalholiday"
                                  }`}>{holiday.type}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      </div>
                    </div>
                    </div>
                  </div>
                  <div className="col-md-6 p-0 m-0">
                    <div className="row bg-white dashboard-table-2 ">
                    <div className="p-0">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="fw-bold">Recent Activity</h5>
                        <select className=" w-auto custom-select"  onChange={(e) => activityFilter(e.target.value)}>
                          <option value="">All Activity</option>
                          <option value="">Uploaded</option>
                          <option value="">Updated</option>
                          <option value="">Downloaded</option>
                          <option value="">Generated</option>
                        </select>
                      </div>

                      <div className=" list-group-flush activityListData">
                        {activities.map((item, index) => (
                          <div
                            key={index}
                            className="list-group-item d-flex justify-content-between align-items-center activity-item my-2"
                          >
                            <div className="d-flex align-items-center">
                                
                            {(() => {
                            switch (item.type) {
                              case 1:
                                return <div className="icon-wrapper dashboard_download_icon me-3"><img src={dashboard_download_icon} alt="icon" className="activity-icon" /></div>;
                              case 2:
                                return <div className="icon-wrapper dashboard_update_icon me-3"><img src={dashboard_update_icon} alt="icon" className="activity-icon" /></div>;
                              case 3:
                                return <div className="icon-wrapper dashboard_upload_icon me-3"><img src={dashboard_upload_icon} alt="icon" className="activity-icon" /></div>;
                              case 4:
                                return <div className="icon-wrapper dashboard_generated_icon me-3"><img src={dashboard_upload_icon} alt="icon" className="activity-icon" /></div>;
                              default:
                                return <div className="icon-wrapper me-3"><img src={dashboard_upload_icon} alt="icon" className="activity-icon" /></div>;
                            }
                          })()}
                              <div>
                                <div className=" activity-item-title">{item.title}</div>
                                <small className="text-muted activity-item-action">{item.action}</small>
                              </div>
                            </div>

                            <div className="text-end">
                              <div className=" activity-item-date">{item.date}</div>
                              <small className="text-muted activity-item-time">{item.time}</small>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    </div>
                  </div>
                  </>
                  )}
                </div>
              </div>
            </div>
        )}

        {userRole !== "SuperiorAdmin" && (
            <div className="row dahsboard-main-row">
              <div className="col-md-12">
                <div className="row dahsboard-box-row" data-tour="dashboard-kpis">
                  <div className="col  dishboard-box-1 m-2">
                    <div className="row m-0">
                      <div className="col-md-12 d-flex justify-content-between  mt-3 p-0">
                        <p className="dashboard-lable-number p-0 m-0">{employeeCount.totals.total_clients}</p>
                        <div className="dashboard-lable-icon-div">
                        <img className='dashboard-lable-icon ' src={dashboard_box_icon_1} alt="no-img" />
                        </div>
                     </div>
                      <div className="col-md-12 p-0 m-0 mt-3">
                        <p className="dashboard-lable-text  m-0 p-0">Organization</p>
                      </div>
                    </div>
                  </div>
                  <div className="col  dishboard-box-2 m-2">
                    <div className="row m-0">
                      <div className="col-md-12 d-flex justify-content-between  mt-3 p-0">
                        <p className="dashboard-lable-number p-0 m-0">{employeeCount.totals.total_units}</p>
                        <div className="dashboard-lable-icon-div">
                        <img className='dashboard-lable-icon ' src={dashboard_box_icon_2} alt="no-img" />
                        </div>
                     </div>
                      <div className="col-md-12 p-0 m-0 mt-3">
                        <p className="dashboard-lable-text  m-0 p-0">Branches</p>
                      </div>
                    </div>
                  </div>
                  <div className="col  dishboard-box-3 m-2">
                    <div className="row m-0">
                      <div className="col-md-12 d-flex justify-content-between  mt-3 p-0">
                        <p className="dashboard-lable-number p-0 m-0">{employeeCount.totals.total_active}</p>
                        <div className="dashboard-lable-icon-div">
                        <img className='dashboard-lable-icon ' src={dashboard_box_icon_3} alt="no-img" />
                        </div>
                     </div>
                      <div className="col-md-12 p-0 m-0 mt-3">
                        <p className="dashboard-lable-text  m-0 p-0">Employee Head Count</p>
                      </div>
                    </div>
                  </div>
                  <div className="col  dishboard-box-4 m-2">
                    <div className="row m-0">
                      <div className="col-md-12 d-flex justify-content-between  mt-3 p-0">
                        <p className="dashboard-lable-number p-0 m-0">{employeeCount.totals.total_latest_joined}</p>
                        <div className="dashboard-lable-icon-div">
                        <img className='dashboard-lable-icon ' src={dashboard_box_icon_4} alt="no-img" />
                        </div>
                     </div>
                      <div className="col-md-12 p-0 m-0 mt-3">
                        <p className="dashboard-lable-text  m-0 p-0">New Employees</p>
                      </div>
                    </div>
                  </div>
                  <div className="col  dishboard-box-5 m-2">
                    <div className="row m-0">
                      <div className="col-md-12 d-flex justify-content-between  mt-3 p-0">
                        <p className="dashboard-lable-number p-0 m-0">{employeeCount.totals.total_separated}</p>
                        <div className="dashboard-lable-icon-div">
                        <img className='dashboard-lable-icon ' src={dashboard_box_icon_5} alt="no-img" />
                        </div>
                     </div>
                      <div className="col-md-12 p-0 m-0 mt-3">
                        <p className="dashboard-lable-text  m-0 p-0">Exit Employees</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="row p-2 mt-1">
                  <div className="col-md-6 ">
                    <div className="row bg-white dashboard-chart1 pt-3" data-tour="dashboard-registers">
                    <div className="d-flex justify-content-between items-center mb-2">
      <h5 className="text-lg font-semibold">Registers Overview</h5>

      <select
        value={fySelectValue}
        onChange={(e) => setSelectedFY(e.target.value)}
        className="custom-select-registers"
        style={{
          backgroundImage: `url(${calendarfy})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "8px center",
          paddingLeft: "30px",
          backgroundSize: "18px 18px",
        }}
      >
        {userRole === "Client" ? (
          fyList.length === 0 ? (
            <option value="">No forms</option>
          ) : (
            fyList.map((fy) => (
              <option key={fy} value={fy}>
                {fy}
              </option>
            ))
          )
        ) : (
          <>
            <option value=""> This FY</option>
            {fyList.map((fy, idx) => (
              <option key={idx} value={fy}>
                {fy}
              </option>
            ))}
          </>
        )}
      </select>
    </div>
                    <div className="dashboard-chart-wrapper">
      <Chart
        key={userRole === "Client" ? `client-fy-${fySelectValue}-${clientRegistersChart.categories.join("-")}` : "admin-registers"}
        options={userRole === "Client" ? clientDashboardOptions : dashboardOptions}
        series={userRole === "Client" ? clientDashboardSeries : dashboardSeries}
        type="area"
        height={200}
      />
    </div>
                    {/* <div className="bg-white shadow-md rounded-2xl p-5 relative">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">Registers Overview</h2>
          <button className="flex items-center gap-2 text-sm border rounded-lg px-3 py-1 bg-gray-50 hover:bg-gray-100">
            📅 This FY
          </button>
        </div>

        <p className="text-blue-600 font-bold text-2xl">3K</p>
        <p className="text-gray-500 text-sm mb-2">Total Number of Form Generated</p>

        <div style={{ height: 260 }}>
          <ResponsiveLine
            data={lineData}
            margin={{ top: 20, right: 20, bottom: 40, left: 50 }}
            xScale={{ type: "point" }}
            yScale={{ type: "linear", min: "auto", max: "auto" }}
            axisBottom={{ tickSize: 0, tickPadding: 10 }}
            axisLeft={{ tickSize: 0, tickPadding: 10 }}
            colors={["#2563EB"]}
            lineWidth={3}
            enablePoints={true}
            pointSize={12}
            pointColor="#fff"
            pointBorderWidth={3}
            pointBorderColor="#2563EB"
            enableGridX={false}
            enableGridY={true}
            useMesh={true}
            theme={{
              textColor: "#6B7280",
              axis: { ticks: { text: { fontSize: 12 } } },
              grid: { line: { stroke: "#E5E7EB", strokeWidth: 1 } },
              tooltip: {
                container: {
                  background: "white",
                  padding: "8px 12px",
                  borderRadius: "8px",
                  fontSize: 12,
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                },
              },
            }}
            tooltip={({ point }) => (
              <div className="bg-white shadow-md rounded-lg p-2 text-sm">
                <p className="font-semibold">{point.data.xFormatted}</p>
                <p className="text-blue-600">Form Generated: {point.data.yFormatted}</p>
              </div>
            )}
          />
        </div>
      </div> */}
                    </div>
                  </div>
                  <div className="col-md-3 p-0 m-0 ">
                    <div className="row bg-white   dashboard-chart2" data-tour="dashboard-status">
                    <div className="dashboard-status-card">
                        {/* Header */}
                        <div className="dashboard-status-card">
                        {/* Header */}
                        <div className="dashboard-status-header">
                          <h5>Status Chart</h5>
                          <select className=" w-auto custom-select-status">
                            <option>Monthly</option>
                            <option>Quarterly</option>
                            <option>Yearly</option>
                          </select>
                        </div>

                        {/* Chart */}
                          <div className="dashboard-status-chart">
                            <ResponsivePie
                              data={pieData}
                              margin={{ top: 22, right: 22, bottom: 22, left: 22 }}
                              innerRadius={0}
                              enableArcLabels={false}
                              enableArcLinkLabels={false}
                              colors={(d) => d.data.color}
                              isInteractive={true}
                              activeOuterRadiusOffset={6}
                              tooltip={() => null}
                              arcLabel={(d) => `${d.value}%`}
                              arcLabelsSkipAngle={0}
                              arcLabelsTextColor="#fff" // set to final color
                              startAngle={-133}   // 👈 rotates start to left
                              endAngle={360}
                            />


                          </div>

                        {/* Legend */}
                        <div className="dashboard-status-legend">
                          {pieData.map((item, idx) => (
                            <>
                            <div key={idx} className="dashboard-status-item">
                              
                              <div>
                                <p className="dashboard-label"><span
                                className="dashboard-dot"
                                style={{ backgroundColor: item.color }}
                              ></span>{item.label}</p>
                                <p className="dashboard-value">{item.value}%</p>
                              </div>
                            </div>
                              {item.label === "Forms Pending" && <div className='dashboard-dot-line'></div>}
                              </>
                          ))}
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                  <div className="col-md-3  p-0 m-0">
                    <div className="row  bg-white   dashboard-chart3 bg-white shadow-sm returns-card" data-tour="dashboard-returns">

                        {/* Header */}
                        <div className="d-flex justify-content-between align-items-center mb-0 returns-card-header mt-2">
                          <h6 className="fw-bold mb-0">Returns</h6>
                          <div className="btn-group btn-group-sm return-btn-main">
                            <button className="return-btn active">1M</button>
                            <button className="return-btn">3M</button>
                            <button className="return-btn">6M</button>
                            <button className=" return-btn">1Y</button>
                          </div>  
                        </div>

                        {/* Scrollable List */}
                        <div className="dashboard-returns-list mt-2">
                          {returnsData.map((item) => (
                            <div key={item.id} className="d-flex align-items-center justify-content-between mb-3">
                              <div className="d-flex align-items-center">
                                <div>
                                  {/* {item.label} */}
                                  {(() => {
                            switch (item.label) {
                              case "1M":
                                return <div className="dashboard_returns_1m returns-icon-div"><img src={dashboard_returns_1m} alt="icon" className="returns-icon" /></div>;
                              case "3M":
                                return <div className="dashboard_returns_3m returns-icon-div"><img src={dashboard_returns_3m} alt="icon" className="returns-icon" /></div>;
                              case "6M":
                                return <div className="dashboard_returns_6m returns-icon-div"><img src={dashboard_returns_6m} alt="icon" className="returns-icon" /></div>;
                              case "1Y":
                                return <div className="dashboard_returns_1y returns-icon-div"><img src={dashboard_returns_1y} alt="icon" className="returns-icon" /></div>;
                              default:
                                return <div className="dashboard_returns_1m returns-icon-div"><img src={dashboard_returns_1m} alt="icon" className="returns-icon" /></div>;
                            }
                          })()}
                                </div>
                                <div>
                                  <div className="form">{item.form}</div>
                                  <div className=" subtitle">{item.subtitle}</div>
                                </div>
                              </div>
                              <div className="text-end  date">{item.date}</div>
                            </div>
                          ))}
                        </div>
                    </div>
                    
                  </div>
                </div>
              </div>
              <div className="col-md-12 dashboard3card">
                <div className="row p-0 m-0 ">
                  {userRole === "Client" ? (
                  <div className="col-md-12  p-0 m-0">
                    <div className="row bg-white dashboard-table-1 client-holidays-expanded" data-tour="dashboard-holidays">
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-3 holidaymainheader">
                        <h5 className="fw-bold mt-1">Upcoming Holidays</h5>
                        <select className=" w-auto custom-select" value={holidayFilterType} onChange={(e) => setHolidayFilterType(e.target.value)}>
                          <option value = "0">All Holidays</option>
                          <option value = "2">Festival Holidays</option>
                          <option value = "1">National Holidays</option>
                        </select>
                      </div>

                      <div className="table-responsive holiday-table-main">
                      <table className="table holiday-table table-borderless  table-striped">
                        <thead className=''>
                          <tr className='p-1'>
                            <th>Name of the Festival</th>
                            <th>State</th>
                            <th>Date</th>
                            <th>Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          {visibleHolidays.length === 0 ? (
                            <tr>
                              <td colSpan={4} className="text-center text-muted py-4">No holidays</td>
                            </tr>
                          ) : (
                            visibleHolidays.map((holiday, index) => (
                            <tr key={index} >
                              <td>{holiday.name}</td>
                              <td>{holiday.address}</td>
                              <td>{holiday.date}</td>
                              <td>
                                <span className={`holidaybadge ${
                                    holiday.type === "National" ? "textdark nationalholiday" : " festivalholiday"
                                  }`}>{holiday.type}
                                </span>
                              </td>
                            </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                      </div>
                    </div>
                    </div>
                  </div>
                  ) : (
                  <>
                  <div className="col-md-6  p-0 m-0">
                    <div className="row bg-white dashboard-table-1">
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-3 holidaymainheader">
                        <h5 className="fw-bold mt-1">Upcoming Holidays</h5>
                        <select className=" w-auto custom-select" onChange={(e) => holidayFilter(e.target.value)}>
                          <option value = "0">All Holidays</option>
                          <option value = "2">Festival Holidays</option>
                          <option value = "1">National Holidays</option>
                        </select>
                      </div>

                      <div className="table-responsive holiday-table-main">
                      <table className="table holiday-table table-borderless  table-striped">
                        <thead className=''>
                          <tr className='p-1'>
                            <th>Name of the Festival</th>
                            <th>State</th>
                            <th>Date</th>
                            <th>Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          {holidays.map((holiday, index) => (
                            <tr key={index} >
                              <td>{holiday.name}</td>
                              <td>{holiday.address}</td>
                              <td>{holiday.date}</td>
                              <td>
                                <span className={`holidaybadge ${
                                    holiday.type === "National" ? "textdark nationalholiday" : " festivalholiday"
                                  }`}>{holiday.type}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      </div>
                    </div>
                    </div>
                  </div>
                  <div className="col-md-6 p-0 m-0">
                    <div className="row bg-white dashboard-table-2 ">
                    <div className="p-0">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="fw-bold">Recent Activity</h5>
                        <select className=" w-auto custom-select"  onChange={(e) => activityFilter(e.target.value)}>
                          <option value="">All Activity</option>
                          <option value="">Uploaded</option>
                          <option value="">Updated</option>
                          <option value="">Downloaded</option>
                          <option value="">Generated</option>
                        </select>
                      </div>

                      <div className=" list-group-flush activityListData">
                        {activities.map((item, index) => (
                          <div
                            key={index}
                            className="list-group-item d-flex justify-content-between align-items-center activity-item my-2"
                          >
                            <div className="d-flex align-items-center">
                                
                            {(() => {
                            switch (item.type) {
                              case 1:
                                return <div className="icon-wrapper dashboard_download_icon me-3"><img src={dashboard_download_icon} alt="icon" className="activity-icon" /></div>;
                              case 2:
                                return <div className="icon-wrapper dashboard_update_icon me-3"><img src={dashboard_update_icon} alt="icon" className="activity-icon" /></div>;
                              case 3:
                                return <div className="icon-wrapper dashboard_upload_icon me-3"><img src={dashboard_upload_icon} alt="icon" className="activity-icon" /></div>;
                              case 4:
                                return <div className="icon-wrapper dashboard_generated_icon me-3"><img src={dashboard_upload_icon} alt="icon" className="activity-icon" /></div>;
                              default:
                                return <div className="icon-wrapper me-3"><img src={dashboard_upload_icon} alt="icon" className="activity-icon" /></div>;
                            }
                          })()}
                              <div>
                                <div className=" activity-item-title">{item.title}</div>
                                <small className="text-muted activity-item-action">{item.action}</small>
                              </div>
                            </div>

                            <div className="text-end">
                              <div className=" activity-item-date">{item.date}</div>
                              <small className="text-muted activity-item-time">{item.time}</small>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    </div>
                  </div>
                  </>
                  )}
                </div>
              </div>
            </div>
        )}

        {/* {userRole === "Admin" && (
            <div className="row mt-3">
                <h4>Admin</h4>
                <div className="row">
                <DashboardCard
                    icon={clientsImg}
                    title="Clients"
                    value={totalclientName}
                    color="green"
                    bg="rgba(0,255,0,0.25)"
                />
                <DashboardCard
                    icon={UnitsImg}
                    title="Units"
                    value={totalunitCount}
                    color="blue"
                    bg="rgba(0,0,255,0.25)"
                />
                <DashboardCard
                    icon={AnchorsImg}
                    title="Anchors"
                    value={anchors}
                    color="purple"
                    bg="rgb(13, 223, 255)"
                />
                </div>

                <div className="row ">
                <div className="col-md-6 d-flex">
                    <div className="chart-card p-3 border rounded bg-white w-100 h-350">
                    <ReactApexChart
                        options={barChartState.options}
                        series={barChartState.series}
                        type="bar"
                        height={350}
                        width="85%"
                    />
                    </div>
                </div>
                <div className="col-md-6 d-flex">
                    <div className="chart-card p-3 border rounded bg-white w-100 h-350">
                    <ReactApexChart
                        options={chartData.options}
                        series={chartData.series}
                        type="pie"
                        height={350}
                        width="80%"
                    />
                    </div>
                </div>
                </div>


            </div>
        )} */}

        {/* {userRole === "Processor" && (
            <div className="row mt-3">
                <h4>Processor</h4>
                <div className="row">

                <DashboardCard
                    icon={<FaCubes size={30} />}
                    title="Units"
                    value={totalunitCount}
                    color="blue"
                    bg="rgba(0,0,255,0.25)"
                />
                <DashboardCard
                    icon={<FaUser size={30} />}
                    title="Forms Pending"
                    value={0}
                    color="purple"
                    bg="rgba(0,255,255,0.25)"
                />
                <DashboardCard
                    icon={<FaBuilding size={30} />}
                    title="Pending"
                    value ={0}
                    color="green"
                    bg="rgba(0,255,0,0.25)"
                />
                </div>
                <div className="row">
                <div className="col-md-6">
                    <div className="p-3 border rounded bg-white">
                    <Stack direction="row" justifyContent="right">
                        <BarChart
                        xAxis={[{ scaleType: 'band', data: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'] }]}
                        series={[{ data: [8167, 1492, 2782, 4253, 8702, 1492, 2782, 4253, 1702, 1782, 4253, 10702] }]}
                        width={600}
                        height={400}
                        />
                    </Stack>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="p-3 border rounded bg-white">
                    <Stack direction="row" justifyContent="right">
                        <LineChart
                        height={400}
                        series={[
                            { data: pData, label: 'pv' },
                            { data: uData, label: 'uv' },
                        ]}
                        xAxis={[{ scaleType: 'point', data: xLabels }]}
                        yAxis={[{ width: 50 }]}
                        margin={margin}
                        />
                    </Stack>
                    </div>
                </div>
                </div>
            </div>
        )} */}

        </div>
      </div>
    </div>
  );

}

export default Dashboard












